(function () {
  'use strict';

  function addToCart(variantId, btn) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    // Build FormData exactly like Dawn's product-form.js does
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
      formData.append('sections', sectionIds.join(','));
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(btn);
      }
    }

    btn.disabled = true;
    btn.classList.add('ce-card-size-btn--loading');

    fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.classList.remove('ce-card-size-btn--loading');
        btn.disabled = false;

        if (response.status) {
          // Shopify returned an error (e.g. sold out)
          console.warn('[CE quick-add] Cart error:', response.description || response.message);
          return;
        }

        // Flash "added" state
        btn.classList.add('ce-card-size-btn--added');
        setTimeout(function () {
          btn.classList.remove('ce-card-size-btn--added');
        }, 1400);

        // Let Dawn open and render the cart drawer / notification
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          // Fallback: redirect to cart
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('[CE quick-add] Fetch error:', err);
        btn.classList.remove('ce-card-size-btn--loading');
        btn.disabled = false;
        // Navigate to product as fallback
        var link = btn.closest('.card-wrapper') && btn.closest('.card-wrapper').querySelector('a[href]');
        if (link) window.location.href = link.href;
      });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ce-card-size-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.dataset.variantId, btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
